module.exports = (__webpack_require__(0))(195);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/widgets/FolderListWidget.js from dll-reference girder_lib
// module id = 216
// module chunks = 0